import { create } from 'zustand';
import { fetchSettings } from '../api/settingsApi';

export const useBannerStore = create(set => ({
  bannerPath: '',

  fetchBannerPath: async () => {
    try {
      const data = await fetchSettings(['banner_path']);
      if (data && data['banner_path']) {
        set({ bannerPath: data['banner_path'] });
      }
    } catch (error) {
      console.error('Error fetching banner path:', error);
    }
  },
}));
